export * from "modules/AppointmentDetails/components/CarDetails/components/CarTyresModal";
export * from "modules/AppointmentDetails/components/CarDetails/components/CustomerInfo";
export * from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus";
